import { render, staticRenderFns } from "./CompanyServiceExpirationSelector.vue?vue&type=template&id=1674c6d9&scoped=true&"
import script from "./CompanyServiceExpirationSelector.vue?vue&type=script&lang=ts&"
export * from "./CompanyServiceExpirationSelector.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyServiceExpirationSelector.vue?vue&type=style&index=0&id=1674c6d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674c6d9",
  null
  
)

export default component.exports